<div class="box" [nbSpinner]="isLoading">
    <div class="box__storage">
        <div class="storage">
            {{"my-files.space"| translate}}: <span class="fw-bold">{{used | fileSize}} / {{total | fileSize}}</span>
        </div>
        <nb-progress-bar [value]="progress" status="info" size="small" [displayValue]="true"
            [attr.current-value]="progress">
        </nb-progress-bar>
    </div>
    <div *ngIf="!isReadOnly" class="box__buttons">
        <button nbButton status="info" size="large" (click)="onNewFolder.next()" [appPermissionDisabled]="permissions.Files.Upload">
            <nb-icon icon="folder-add-outline"></nb-icon>
            {{'device.files.new-catalog' | translate}}
        </button>
        <button nbButton status="primary" size="large" (click)="onUpload.next()" [appPermissionDisabled]="permissions.Files.Upload">
            <nb-icon icon="upload-outline"></nb-icon>
            {{'device.files.upload' | translate}}
        </button>
    </div>
</div>